// import React, { useState, useRef, useEffect } from "react";
// import AvatarEditor from "react-avatar-editor";
// import { useDropzone } from "react-dropzone";
// import Compressor from "compressorjs";
// import "./profileImageUpload.css"
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faFileUpload, faCheck, faPlus, faTrash } from "@fortawesome/free-solid-svg-icons";

// const ImageUpload = ({ onImageAdd, errors }) => {
//   const [images, setImages] = useState([]);
//   const [currentImage, setCurrentImage] = useState(null);
//   const [currentIndex, setCurrentIndex] = useState(0);
//   const [scale, setScale] = useState(1);
//   const editorRef = useRef(null);
//   const [imageError, setImageError] = useState("");
//   const [imagesAdded, setImagesAdded] = useState([]);

//   const allowedFileTypes = ["image/png", "image/jpeg", "image/jpg"];
//   const maxSize = 2 * 1024 * 1024; // 2MB

//   useEffect(() => {
//     if(errors.images){
//         setImageError(errors.images);
//     }
//   },[errors.images]);

//   const onDrop = (acceptedFiles) => {
//     if (acceptedFiles.length === 0) return;

//     const file = acceptedFiles[0];

//     if (!allowedFileTypes.includes(file.type)) {
//       setImageError("Only PNG, JPG, and JPEG formats are allowed!");
//       return;
//     }

//     if (file.size > maxSize) {
//       setImageError("File size must be under 2MB!");
//       return;
//     }

//     new Compressor(file, {
//       quality: 0.8,
//       success(result) {
//         const reader = new FileReader();
//         reader.onload = () => {
//           setCurrentImage(reader.result);
//           setImageError("");
//         };
//         reader.readAsDataURL(result);
//       },
//       error(err) {
//         console.error("Compression error:", err);
//       },
//     });
//   };

//   const { getRootProps, getInputProps } = useDropzone({
//     onDrop,
//     multiple: false,
//     accept: "image/png, image/jpeg, image/jpg",
//     maxSize,
//   });

//   const handleImageSubmit = () => {
//     if (editorRef.current) {
//       const canvas = editorRef.current.getImageScaledToCanvas();

//       canvas.toBlob((blob) => {
//         if (blob) {
//           const file = new File([blob], `profile_image_${imagesAdded.length}.png`, { type: "image/png" });

//           // Add to imagesAdded array
//           const newImagesAdded = [...imagesAdded, file];
//           setImagesAdded(newImagesAdded);

//           // Pass all images to parent
//           onImageAdd(newImagesAdded);

//           // Reset current image editor
//           setCurrentImage(null);
//           setScale(1);
//         }
//       }, "image/png");
//     }
//   };

//   const handleCancel = () => {
//     setCurrentImage(null);
//     setScale(1);
//     setImageError("");
//   };

//   const handleRemoveImage = (index) => {
//     const newImagesAdded = [...imagesAdded];
//     newImagesAdded.splice(index, 1);
//     setImagesAdded(newImagesAdded);
//     onImageAdd(newImagesAdded);
//   };

//   return (
//     <div className="image-upload">
//       {currentImage ? (
//         <div className="editor-container">
//           <AvatarEditor
//             ref={editorRef}
//             image={currentImage}
//             width={200}
//             height={200}
//             border={50}
//             scale={scale}
//             borderRadius={100}
//           />
//           <input
//             type="range"
//             min="1"
//             max="3"
//             step="0.1"
//             value={scale}
//             onChange={(e) => setScale(parseFloat(e.target.value))}
//           />
//           <div className="button-group">
//             <button type="button" onClick={handleImageSubmit}>
//               Add Image
//             </button>
//             <button type="button" onClick={handleCancel} className="cancel-btn">Cancel</button>
//           </div>
//         </div>
//       ) : (
//         <div {...getRootProps()} className="dropzone">
//           <input {...getInputProps()} />
//           <p>Drag & drop a Profile Image or click to select</p>
//           <FontAwesomeIcon icon={faFileUpload} className="uploadIcon"/>
//         </div>
//       )}

//       {imagesAdded.length > 0 && (
//         <div className="images-preview">
//           <h4>Selected Images ({imagesAdded.length})</h4>
//           <div className="image-thumbnails">
//             {imagesAdded.map((_, index) => (
//               <div key={index} className="image-thumbnail">
//                 <div className="thumbnail-number">{index + 1}</div>
//                 <button
//                   type="button"
//                   className="remove-image"
//                   onClick={() => handleRemoveImage(index)}
//                 >
//                   <FontAwesomeIcon icon={faTrash} />
//                 </button>
//               </div>
//             ))}
//           </div>
//         </div>
//       )}

//       <span className="error">{imageError}</span>
//     </div>
//   );
// };

// export default ImageUpload;

import React, { useState, useRef, useEffect } from 'react';
import AvatarEditor from 'react-avatar-editor';
import { useDropzone } from 'react-dropzone';
import Compressor from 'compressorjs';
import './profileImageUpload.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileUpload, faCheck } from '@fortawesome/free-solid-svg-icons';

const ImageUpload = ({ onImageAdd, errors }) => {
  const [image, setImage] = useState(null);
  const [scale, setScale] = useState(1);
  const editorRef = useRef(null);
  const [imageError, setImageError] = useState('');
  const [imageAdded, setImageAdded] = useState(false);

  const allowedFileTypes = ['image/png', 'image/jpeg', 'image/jpg'];

  const maxSize = 2 * 1024 * 1024;

  useEffect(() => {
    if (errors.image) {
      setImageError(errors.image);
    }
  }, [errors.image]);

  const onDrop = (acceptedFiles) => {
    const file = acceptedFiles[0];

    if (!allowedFileTypes.includes(file.type)) {
      // alert("Only PNG, JPG, and JPEG formats are allowed!");
      setImageError('Only PNG, JPG, and JPEG formats are allowed!');
      return;
    }

    if (file.size > maxSize) {
      // alert("File size must be under 2MB!");
      setImageError('File size must be under 2MB!');
      return;
    }

    new Compressor(file, {
      quality: 0.8,
      success(result) {
        const reader = new FileReader();
        reader.onload = () => setImage(reader.result);
        reader.readAsDataURL(result);
        setImageError('');
        setImageAdded(false);
      },
      error(err) {
        console.error('Compression error:', err);
      },
    });
  };

  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    multiple: false,
    accept: 'image/png, image/jpeg, image/jpg',
    maxSize,
  });

  const handleImageSubmit = () => {
    if (editorRef.current) {
      const canvas = editorRef.current.getImageScaledToCanvas();

      canvas.toBlob((blob) => {
        if (blob) {
          const file = new File([blob], 'cropped_profile_image.png', {
            type: 'image/png',
          });
          onImageAdd(file);
          setImageAdded(true);
        }
      }, 'image/png');
    }
  };

  const handleCancel = () => {
    setImage(null);
    setScale(1);
    setImageError('');
    setImageAdded(false);
  };

  return (
    <div className='image-upload'>
      {!image ? (
        <div {...getRootProps()} className='dropzone'>
          <input {...getInputProps()} />
          <p>Drag & drop a Profile Image or click to select</p>
          <FontAwesomeIcon icon={faFileUpload} className='uploadIcon' />
        </div>
      ) : (
        <div className='editor-container'>
          <AvatarEditor
            ref={editorRef}
            image={image}
            width={200}
            height={200}
            border={50}
            scale={scale}
            borderRadius={100}
          />
          <input
            type='range'
            min='1'
            max='3'
            step='0.1'
            value={scale}
            onChange={(e) => setScale(parseFloat(e.target.value))}
          />
          <div className='button-group'>
            {imageAdded ? (
              <p className='image-added-text'>
                <FontAwesomeIcon icon={faCheck} className='uploadIcon' />
                Image Added
              </p>
            ) : (
              <button type='button' onClick={handleImageSubmit}>
                Add Image
              </button>
            )}
            <button type='button' onClick={handleCancel} className='cancel-btn'>
              Cancel
            </button>
          </div>
        </div>
      )}
      <span className='error'>{imageError}</span>
    </div>
  );
};

export default ImageUpload;
